var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.1,
    height: 18.994,
    viewBox: "0 0 13.1 18.994",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-3 -1036.862)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect5392",
    d: "M9.55.5A1.975,1.975,0,0,0,7.585,2.465H6.275a.655.655,0,0,0-.655.655v.655H3.655A.655.655,0,0,0,3,4.43v14.41a.655.655,0,0,0,.655.655h11.79a.655.655,0,0,0,.655-.655V4.43a.655.655,0,0,0-.655-.655H13.48V3.12a.655.655,0,0,0-.655-.655h-1.31A1.975,1.975,0,0,0,9.55.5Zm0,1.31a.645.645,0,0,1,.655.655V3.12a.655.655,0,0,0,.655.655h1.31v1.31H6.93V3.775H8.24a.655.655,0,0,0,.655-.655V2.465A.645.645,0,0,1,9.55,1.81ZM4.31,5.085H5.62V5.74a.655.655,0,0,0,.655.655h6.55a.655.655,0,0,0,.655-.655V5.085h1.31v13.1H4.31Z",
    transform: "translate(0 1036.362)",
    fill: "#040227"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteIcon);
export default __webpack_public_path__ + "static/media/note-icon.616f1454e82b55ee698c2ad597e6cd5d.svg";
export { ForwardRef as ReactComponent };